var exports = {
  "Ll": "AgentTaskSubRow__fAKlP2",
  "tH": "AgentTaskGridCell__43f5K6",
  "I8": "statusIcon__gl8XDj",
  "Z5": "agentIcon__tejOa-",
  "DD": "title__7Myn71",
  "o1": "titleMuted__gcXSPf",
  "qr": "elapsedTime__7rDKZk",
  "M3": "connector__0N2KUP",
  "LN": "connectorMiddle__gTTSXo",
  "WW": "connectorLast__mVIp6p",
  "FG": "contentWrapper__FjhKjs",
  "MK": "kebabButton__3Kzxre",
};

module.exports = exports;
